import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  showDeleteDialog,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import LoadingFetchData from "../../utility/LoadingFetchData";
import SVG from "react-inlinesvg";
import { Button, Col, Row } from "react-bootstrap";
import { NumberSequenceCreate } from "./NumberSequenceCreate";
import { editNumberSequence, removeSequence } from "./businessGroupSlice";

export const SequenceTable = ({
  data,
  page,
  sizePerPage,
  sortField,
  sortOrder,
  onTableChange,
  totalSize,
  loading,
  handleSearch,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);
  const [dataRow, setDataRow] = useState(null);
  const [id, setId] = useState("");

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDelete = async (row) => {
    const params = { sequence_id: `${row.sequence_id}` };
    const action = await showDeleteDialog(
      `Are you sure you want to delete?<br><strong>${row.office_code}</strong>`
    );
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeSequence({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await handleClose;
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
            onClick={(e) => {
              setDataRow(row);
              setShow(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
            </span>
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
            onClick={() => handleDelete(row)}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
        {row.is_enable === "Y" && (
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Disabled</Tooltip>}
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={() => handleDisabled(e, row, rowIndex)}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/New/eye-slash.svg")}
                />
              </span>
            </div>
          </OverlayTrigger>
        )}
        {row.is_enable === "N" && (
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Enabled</Tooltip>}
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={() => handleEnable(e, row, rowIndex)}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                <SVG src={toAbsoluteUrl("/media/svg/icons/New/eye.svg")} />
              </span>
            </div>
          </OverlayTrigger>
        )}
      </div>
    );
  };
  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
    {
      text: "Name",
      dataField: "sequence_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Start Number",
      dataField: "next_num",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Num.Length",
      dataField: "num_size",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Reset Setting",
      dataField: "reset_setting",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      style: { minWidth: "200px" },
      headerAlign: "center",
      align: "center",
    },
  ];

  const handleDisabled = async (e, row, rowIndex) => {
    const params = {
      sequence_id: row.sequence_id,
      is_enable: "N",
    };
    console.log(params);

    const action = await showConfirmDialog(`Are you sure want to disabled?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editNumberSequence(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const handleEnable = async (e, row, rowIndex) => {
    const params = {
      sequence_id: row.sequence_id,
      is_enable: "Y",
    };
    console.log(params);

    const action = await showConfirmDialog(`Are you sure want to enable?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editNumberSequence(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  // Func Create

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
        bootstrap4
        
        keyField="user_id"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        sort={{ dataField: sortField, order: sortOrder }}
        hover
        striped
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
      {/* Footer */}

      {/* Modal Create */}
      <NumberSequenceCreate
        isOpen={show}
        handleShow={handleShow}
        dataRow={dataRow}
        setDataRow={setDataRow}
        setShow={setShow}
      />
    </>
  );
};
